import type { SubAccount } from '@interfaces/goalSubAccountTypes';
import type { SubAccountReport } from '@interfaces/subAccountReport';

/** Falls back to `report.id` when `subAccount` isn't resolved. */
export const subAccountReportId = (
  report: Pick<SubAccountReport, 'id'> & {
    subAccount?: Pick<SubAccount, 'id'>;
  },
): string => report.subAccount?.id ?? report.id;

/** Draft / highlight key for a (subAccount, financialProduct) pair.
 * Operand order is subAccount-first — distinct from `holdingTradeKey(securityId, subAccountId)`
 * in `utils.ts`, which joins the same ids in reverse for draft-trade maps. */
export const allocationCellKey = (
  subAccountId: string,
  financialProductId: string,
) => `${subAccountId}_${financialProductId}`;

/** Parses a key produced by `allocationCellKey` back into its parts.
 * Splits on the first `_` only — assumes ids never contain `_` (true for Mongo ObjectIds). */
export const parseAllocationCellKey = (
  key: string,
): { subAccountId: string; financialProductId: string } => {
  const sep = key.indexOf('_');
  if (sep === -1) {
    throw new Error(`parseAllocationCellKey: malformed key "${key}"`);
  }
  return {
    subAccountId: key.slice(0, sep),
    financialProductId: key.slice(sep + 1),
  };
};
